import { MinzeElement, Attrs } from 'minze'

export interface LvcHandDrawnBox1 {
  inject: string
}

export class LvcHandDrawnBox1 extends MinzeElement {
  attrs: Attrs = [['inject', null]]
  parsedAttrs: any = {}
  static observedAttributes = ['inject']

  onAttributeChange(
    name?: string,
    oldValue?: string | null,
    newValue?: string | null
  ): Promise<void> | void {
    if (name === 'inject' && newValue) {
      this.parsedAttrs = JSON.parse(newValue)
      this.rerender()
    }
  }

  html = () => `
    <!-- Corners -->
    <svg viewBox="0 0 84 84" part="border-top-left">
      <path d="M83.333 10.046v73.287H27.387l.244-18.958c.191-30.207 24.924-54.675 55.16-54.332l.542.003Z" class="background-from"/>
      <path d="M83.333 5.88v8.333l-.589-.004c-27.93-.317-50.77 22.29-50.947 50.193l-.244 18.931H23.22l.244-18.984C23.67 31.836 50.295 5.507 82.838 5.876l.495.004Z" class="border"/>
    </svg>
    <svg viewBox="0 0 84 84" part="border-top-right">
      <path d="m0 8.706 17.333.105c30.292.298 54.375 25.359 53.625 55.596l-.417 18.926H0V8.706Z" class="background-to"/>
      <path d="m0 4.54 17.374.105c32.62.321 58.557 27.304 57.75 59.867v.002l-.416 18.819h-8.335l.42-19.029c.692-27.914-21.537-51.051-49.501-51.326L0 12.873V4.54Z" class="border"/>
    </svg>
    <svg viewBox="0 0 84 84" part="border-bottom-left">
      <path d="M83.333 0v58.553l-2.073-.057c-29.853-.984-52.77-26.021-52.141-55.734L29.159 0h54.174Z" class="background-from"/>
      <path d="m33.326 0-.041 2.851c-.581 27.432 20.551 50.572 48.113 51.48l1.935.053v8.337l-2.21-.061c-32.144-1.059-56.847-27.993-56.17-59.986L24.992 0h8.334Z" class="border"/>
    </svg>
    <svg viewBox="0 0 84 84" part="border-bottom-right">
      <path d="m70.894 0-.227 7.296C69.5 35.454 46.625 57.146 18.542 57.683L0 57.966V0h70.894Z" class="background-to"/>
      <path d="m75.062 0-.232 7.468c-1.259 30.377-25.913 53.801-56.209 54.381L0 62.133v-8.334l18.462-.282c25.871-.495 46.967-20.454 48.042-46.395L66.726 0h8.336Z" class="border"/>
    </svg>

    <!-- Sides -->
    <div part="border-top">
      <svg viewBox="0 0 4121 84" preserveAspectRatio="none">
        <defs>
          <linearGradient id="gradient">
            <stop offset="0%" class="gradient-stop-1" />
            <stop offset="100%" class="gradient-stop-2" />
          </linearGradient>
        </defs>
        <path d="M0 83.333V10.046c174.488 1.974 340.835.317 546.825-1.734 66.217-.66 136.533-1.36 212.533-1.993 312.621-2.607 721.321-4.084 1336.5 3.048 484.425 5.616 846.513 4.015 1161.73 1.741 45.725-.329 90.466-.673 134.454-1.012 253.323-1.948 481.603-3.703 728.787-1.39v74.627H-.001Z" style="fill:url(#gradient)"/>
        <path d="M4120.83 12.873c-247.153-2.314-475.431-.558-728.755 1.39-43.988.338-88.731.682-134.456 1.012-315.242 2.274-677.354 3.875-1161.81-1.742-615.141-7.132-1023.82-5.654-1336.42-3.048-75.998.634-146.312 1.334-212.527 1.993C340.86 14.53 174.498 16.186-.004 14.213V5.88c174.474 1.973 340.807.317 546.784-1.735 66.218-.659 136.537-1.359 212.54-1.993C1071.96-.455 1480.685-1.932 2095.9 5.2c484.392 5.616 846.455 4.016 1161.65 1.742 45.724-.33 90.465-.674 134.452-1.012 253.321-1.948 481.603-3.704 728.819-1.39v8.333Z" class="border"/>
      </svg>
    </div>
    <div part="border-left">
      <svg viewBox="0 0 84 1996" preserveAspectRatio="none">
        <path d="M27.387 0h55.946v1995.83H29.159c3.557-171.934-2.647-336.158-9.763-507.292-.469-11.284-.942-22.592-1.417-33.938-6.761-161.658-13.812-330.246-13.812-517.737-.001-211.592 5.349-368.9 10.957-514.142.608-15.725 1.218-31.304 1.824-46.8C21.727 253.878 26.291 137.32 27.387-.004Z" class="background-from"/>
        <path d="M31.553 0c-1.095 137.38-5.66 253.99-10.441 376.088-.607 15.495-1.217 31.074-1.824 46.798C13.682 568.082 8.333 725.341 8.333 936.867c.001 187.428 7.051 355.959 13.809 517.563.475 11.346.948 22.655 1.417 33.939 7.118 171.187 13.322 335.464 9.767 507.465h-8.334c3.557-171.9-2.646-336.056-9.759-507.119l-1.417-33.937C7.053 1293.066.001 1124.421 0 936.867c-.001-211.658 5.351-369.016 10.961-514.303.607-15.726 1.217-31.305 1.824-46.802C17.561 253.774 22.124 137.268 23.22 0h8.333Z" class="border"/>
      </svg>
    </div>
    <div part="border-right">
      <svg viewBox="0 0 84 1996" preserveAspectRatio="none">
        <path d="M0 2053.8c-345.767 6.454-893.667 10.368-1387.17 13.892-265.162 1.896-514.621 3.679-708.596 5.67-556.019 5.717-1574.33-4.228-2025.07-18.976v-58.552H-.006v57.966ZM70.541 0c-10.105 407.217-9.409 842.479 1.751 970.387 10.27 117.778 8.373 781.716-1.398 1025.45H0V.007h70.541Z" class="background-to"/>
        <path d="M74.708 0c-10.102 407.033-9.421 842.165 1.735 970.026 10.273 117.814 8.391 781.849-1.381 1025.81h-8.336c9.77-243.373 11.683-907.333 1.415-1025.08C56.976 842.787 56.266 407.32 66.373.006h8.335Z" class="border"/>
      </svg>
    </div>
    <div part="border-bottom">
      <svg viewBox="0 0 4121 84" preserveAspectRatio="none">
        <defs>
          <linearGradient id="gradient">
            <stop offset="0%" class="gradient-stop-1" />
            <stop offset="100%" class="gradient-stop-2" />
          </linearGradient>
        </defs>
        <path d="M4120.83 57.966c-345.767 6.454-893.667 10.368-1387.17 13.892-265.162 1.896-514.62 3.679-708.595 5.671-556.019 5.717-1574.33-4.228-2025.07-18.976V0h4120.83v57.966Z" style="fill:url(#gradient)"/>
        <path d="M4120.83 53.799v8.334c-345.812 6.454-893.67 10.368-1387.14 13.892-265.157 1.896-514.611 3.679-708.583 5.671h.001C1469.095 87.412 450.838 77.468-.002 62.721v-8.337c450.629 14.749 1469 24.695 2025.02 18.979 193.978-1.992 443.441-3.775 708.609-5.671 493.486-3.524 1041.37-7.438 1387.2-13.893Z" class="border"/>
      </svg>
    </div>
  `

  css = () => `
    :host {}

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }

    svg .border {
      fill: ${this.parsedAttrs.borderColor};
    }

    svg .background-from {
      fill: ${this.parsedAttrs.bgFromColor || this.parsedAttrs.bgColor};
    }

    svg .background-to {
      fill: ${this.parsedAttrs.bgToColor || this.parsedAttrs.bgColor};
    }

    svg .gradient-stop-1 {
      stop-color: ${this.parsedAttrs.bgFromColor || this.parsedAttrs.bgColor};
    }

    svg .gradient-stop-2 {
      stop-color: ${this.parsedAttrs.bgToColor || this.parsedAttrs.bgColor};
    }

    :host-context(.hover) svg .border {
      fill: ${this.parsedAttrs.hoverBorderColor || this.parsedAttrs.borderColor};
    }

    :host-context(.hover) svg .background-from {
      fill: ${this.parsedAttrs.hoverBgFromColor || this.parsedAttrs.hoverBgColor || this.parsedAttrs.bgFromColor || this.parsedAttrs.bgColor};
    }

    :host-context(.hover) svg .background-to {
      fill: ${this.parsedAttrs.hoverBgToColor || this.parsedAttrs.hoverBgColor || this.parsedAttrs.bgToColor || this.parsedAttrs.bgColor};
    }

    :host-context(.hover) svg .gradient-stop-1 {
      stop-color: ${this.parsedAttrs.hoverBgFromColor || this.parsedAttrs.hoverBgColor || this.parsedAttrs.bgFromColor || this.parsedAttrs.bgColor};
    }

    :host-context(.hover) svg .gradient-stop-2 {
      stop-color: ${this.parsedAttrs.hoverBgToColor || this.parsedAttrs.hoverBgColor || this.parsedAttrs.bgToColor || this.parsedAttrs.bgColor};
    }
  `
}
